module.exports = __webpack_public_path__ + "img/ic_launcher_1.6cd0193b.png";